
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ButtonBlock',
  props: {
    label: {
      type: String, default: ''
    },
    secondaryLabel: {
      type: String, default: ''
    },
    primaryType: {
      type: String, default: 'button'
    },
    disabled: {
      type: Boolean
    }
  },
  setup(props, { listeners }) {
    return {
      hasSecondaryButton: !!listeners['secondary-action']
    };
  }
});
